import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/_components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NavSection"] */ "/app/src/app/_components/NavSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/app/src/app/trpc/react.tsx");
